<div class="clearfix pb-1" id="scroll">
    <div class="container">
        <div class="clsTermConditions">
            <!-- <div class="clearfix pb-4">
                <h1> Communication & Operations Mobile Engagement Tool Terms and Conditions </h1>
    
                <p>
                    These Terms and Conditions constitute a legally binding agreement ("Agreement") made between you, whether personally as
                    a professional, or on behalf of an entity you represent ("You" or "Customer") and Cardinality.Al whose principal place
                    of business is VA, U.S.A. ("Cardinality", "we," "us" or "our"), concerning your access to and contracting a PICS
                    offering ("Product").
                </p>
    
                <p>
                    Nothing in these Terms and Conditions will alter, amend, or otherwise affect the rights and responsibilities of
                    Cardinality AI and The West virginia Division of Family Children Services (“DFCS”) in accordance with any existing agreement
                    related to the Communication & Operations Mobile Engagement Tool or as detailed in the End User License Agreement (“EULA”).
                </p>
    
                <div class="clearfix">
                    <h2> Confidentiality agreement: </h2>
    
                    <p>
                        You agree that by contracting our Product, you have read, understood, and agree to be bound by these Terms and
                        Conditions, which may be executed via electronic signature, electronic online communications, or via emailed PDF-format
                        document.
                    </p>
    
                    <p>
                        You agree that you shall maintain strictly confidential, and shall not reveal nor by any means transfer to a third
                        party, or use any and all information related to the Services, products, materials, and prototypes, and any technical
                        documentation that forms part of the Know-how of Product, or that it has received from third parties, or any other
                        information to which you have access by virtue of accepting these terms.
                    </p>
    
                    <p>
                        You may not use our products for any illegal or unauthorized purpose nor may you, in the use of the Service, violate any
                        laws in your jurisdiction (including but not limited to copyright laws).
                    </p>
                </div>
    
                <div class="clearfix">
                    <h2> Data usage &amp; protection: </h2>
    
                    <p>
                        You agree to comply with applicable data usage and protection laws in relation to the Product. Data usage policy is
                        primarily concerned with privacy and compliance and exists to ensure that the data you collect, use, and store is not
                        abused. Legislation such as HIPAA have very strict guidelines on how customer data can be used, and non-compliance can
                        have serious very strict consequences.
                    </p>
    
                    <p>
                        This ties into the access policy, since employees, contractors, and other workers should only be able to access data
                        they require to do their jobs. You should also have strict guidelines in place regarding who is able to update data and
                        under what circumstances they are allowed to do so.
                    </p>
    
                    <p>
                        Data Usage Policy is designed to let you know how we collect, use, and disclose information through the websites, mobile
                        applications, and other online services and products.
                    </p>
    
                    <p>
                        All data obtained and held by us must be processed according to a set of core principles. In accordance with these
                        principles, we will ensure that:
                    </p>
    
                    <ul class="clearfix pl-40">
                        <li> Processing will be fair, lawful and transparent </li>
                        <li> Data collected for specific, explicit, and legitimate purposes </li>
                        <li> Data collected will be adequate, relevant and limited to what is necessary for the purposes of processing </li>
                        <li> Data will be kept accurate and up to date. Data which is found to be inaccurate will be rectified or erased without delay Data is not kept for longer than is necessary for its given purpose </li>
                        <li> Data will be processed in a manner that ensures appropriate security of personal data including protection against unauthorized or unlawful processing, accidental loss, destruction or damage by using appropriate technical or organization measures </li>
                    </ul>
                </div>
    
                <div class="clearfix">
                    <h2> Disclaimer of warranties; Limitation of liability: </h2>
    
                    <p>
                        We do not guarantee, represent or warrant that your use of our service will be uninterrupted, timely, secure or
                        error-free. We do not warrant that the results that may be obtained from the use of the service will be accurate or
                        reliable.
                    </p>
    
                    <p>
                        You agree that from time to time we may remove the service for indefinite periods of time or cancel the service at any
                        time, without notice to you.
                    </p>
    
                    <p>
                        You expressly agree that your use of, or inability to use, the service is at your sole risk. The service and all
                        products and services delivered to you through the service are (except as expressly stated by us) provided 'as is' and
                        'as available' for your use, without any representation, warranties, or conditions of any kind, either express or
                        implied, including all implied warranties or conditions of merchantability, merchantable quality, fitness for a
                        particular purpose, durability, title, and non-infringement.
                    </p>
                </div>
    
                <div class="clearfix">
                    <h2> Severability: </h2>
    
                    <p>
                        If any provision of these Terms of Service is determined to be unlawful, void, or unenforceable, such provision shall
                        nonetheless be enforceable to the fullest extent permitted by applicable law, and the unenforceable portion shall be
                        deemed to be severed from these Terms of Service, such determination shall not affect the validity and enforceability of
                        any other remaining provisions.
                    </p>
                </div>
    
                <div class="clearfix">
                    <h2> Governing law: </h2>
    
                    <p>
                        These Terms shall be governed and construed in accordance with the laws of West virginia, United States, without regard to its
                        conflict of law provisions.
                    </p>
    
                    <p>
                        Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. If any
                        provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions of these Terms will
                        remain in effect.
                    </p>
                </div>
    
                <div class="clearfix">
                    <h2> Changes: </h2>
    
                    <p>
                        By continuing to access or use our Service after any revisions become effective, you agree to be bound by the revised
                        terms. If you do not agree to the new terms, you are no longer authorized to use the Service.
                    </p>
    
                    <p>
                        If you have any questions about these Terms, please contact us at <a href="mailto:macs@dohs.wv.gov">MACS</a>.
                    </p>
                </div>
            </div> -->

            <div class="clearfix">
                <h1> Communication & Operations Mobile Engagement Tool Privacy Policy </h1>
            
                <p>
                    Individuals who visit the WV.gov website are important to us. Because visitors to our website are important, we
                    do not
                    capture personal information about them without their permission. We endeavor to collect only the minimum amount
                    of
                    information needed to meet the purposes for which the website was created.
                </p>
            
                <div class="clearfix mb-3">
                    <h2> Use of This Policy </h2>
            
                    <p>
                        Various websites are linked through the WV.gov website. State and local government agencies may have their
                        own privacy
                        statements posted on their sites, which take precedence over this policy. The WV.gov Privacy Statement does
                        not apply to
                        non-West Virginia State Government websites that may be linked from WV.gov. Visitors should read the privacy
                        policies of
                        individual sites and be cautious about providing personally identifiable information without a clear
                        understanding of
                        how the information will be used.
                    </p>
                </div>
            
                <div class="clearfix mb-3">
                    <h2> Privacy Statement </h2>
            
                    <h3> Public Disclosure </h3>
            
                    <p>
                        All information collected on the WV.gov website will be treated the same as any written communication and is
                        subject to
                        the confidentiality and public disclosure provisions of <a href="https://code.wvlegislature.gov/29B/"
                          target="_blank"  rel="noopener">West Virginia Code Chapter 29B</a>.
                    </p>
                </div>
            
                <div class="clearfix mb-3">
                    <h2> Visitors to the WV.gov Website </h2>
            
                    <p>
                        We may collect some or all of the following information about visitors who view or download information from
                        our
                        website:
                    </p>
            
                    <div class="clearfix">
                        <table class="table" aria-label="User access table">
                            <thead>
                                <tr>
                                    <th class="clsWidth-140"> Information </th>
                                    <th> Definition </th>
                                </tr>
                            </thead>
            
                            <tbody>
                                <tr>
                                    <td class="clsWidth-140"> Date </td>
                                    <td> Date the visit occurred. </td>
                                </tr>
            
                                <tr>
                                    <td class="clsWidth-140"> Time </td>
                                    <td> Time the visit occurred. </td>
                                </tr>
            
                                <tr>
                                    <td class="clsWidth-140"> Client IP </td>
                                    <td>
                                        ​Unique Internet Protocol (IP) address of the website visitor. The IP address recorded is
                                        normally that of the visitor's
                                        Internet service provider, e.g., aol.com if the visitor connects from an America Online
                                        account.
                                    </td>
                                </tr>
            
                                <tr>
                                    <td class="clsWidth-140"> Server IP </td>
                                    <td>
                                        Unique Internet Protocol (IP) address of the State of West Virginia web server accessed.
                                    </td>
                                </tr>
            
                                <tr>
                                    <td class="clsWidth-140"> HTTP Status </td>
                                    <td>
                                        Hyper Text Transfer Protocol (HTTP) error code. E.g., "404 Requested Page Not Found."
                                    </td>
                                </tr>
            
                                <tr>
                                    <td class="clsWidth-140"> HTTP Request URL </td>
                                    <td>
                                        Identifies the web page or file requested by the website visitor.
                                    </td>
                                </tr>
            
                                <tr>
                                    <td class="clsWidth-140"> Bytes Sent </td>
                                    <td>
                                        Amount of data sent from the web server to website visitor during that connection.
                                    </td>
                                </tr>
            
                                <tr>
                                    <td class="clsWidth-140"> Bytes Received </td>
                                    <td>
                                        Amount of data sent from website visitor to the web server.
                                    </td>
                                </tr>
            
                                <tr>
                                    <td class="clsWidth-140"> User Agent </td>
                                    <td>
                                        Type of web browser or other client software that made request to the web server.
                                    </td>
                                </tr>
            
                                <tr>
                                    <td class="clsWidth-140"> Referrer </td>
                                    <td>
                                        Uniform Resource Locator (URL) that referred to the requested file.
                                    </td>
                                </tr>
            
                                <tr>
                                    <td class="clsWidth-140"> Protocol Version </td>
                                    <td>
                                        Version of HTTP used by the visitor's web browser software.
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
            
                    <p>
                        The information we collect is used to improve the content of our web services and help us understand how
                        people are
                        using our services. We analyze our website logs to continually improve the value of the materials available
                        on our site.
                        The information in our website logs is not personally identifiable, and we make no attempt to link it with
                        the
                        individuals that browse our website. Some of this statistical information, such as a running count of the
                        number of
                        visitors, may be displayed on the website or shared with other state governments to aid in the provision of
                        better
                        service to the public.
                    </p>
                </div>
            
                <div class="clearfix mb-3">
                    <h2> Personally Identifiable Information </h2>
            
                    <p>
                        "Personally identifiable information" is information about a person that is readily identifiable to that
                        specific
                        individual. It includes, for example, an individual's name, street address, e-mail address, or phone number.
                    </p>
            
                    <p>
                        Personally identifiable information will not be collected unless you voluntarily send an e-mail message,
                        fill out and
                        send an online form, or fill out personal information and send in a survey. Your choice not to participate
                        in these
                        activities will not impair your ability to access certain information or obtain a service from state
                        government (though
                        you may not be able to complete the transaction or service online). Unless specifically protected under
                        state law, any
                        information provided may be inspected by the public or disclosed in a legal proceeding.
                    </p>
                </div>
            
                <div class="clearfix mb-3">
                    <h2> E-mail Messages </h2>
            
                    <p class="mb-1">
                        E-mail messages, sent to any West Virginia State Government address, will be treated the same as any other
                        written
                        communication. They may be subject to public inspection or legal disclosure and may be saved for a period of
                        time before
                        they are destroyed. E-mail or other information requests sent to the state website may be maintained in
                        order to respond
                        to the request, forward that request to the appropriate agency, or to provide the web designer with valuable
                        customer
                        feedback to assist in improving the site. E-mail addresses obtained as a result of a request to the state
                        site will not
                        be sold or given to private companies for marketing purposes.
                    </p>
                </div>
            
                <div class="clearfix mb-3">
                    <h2> Electronic Forms </h2>
            
                    <p class="mb-1">
                        Any other information provided by a visitor at the request of an agency of West Virginia State Government,
                        such as the
                        completion and electronic filing of a form, will be considered to be voluntarily provided by the visitor and
                        will be
                        treated in the same manner as information provided in written form or in person during a visit to the
                        agency.
                        Information provided may be subject to public inspection and legal disclosure and may be saved for a period
                        of time
                        before it is destroyed. It may be shared with another state agency for appropriate action.
                    </p>
                </div>
            
                <div class="clearfix mb-3">
                    <h2> Surveys </h2>
            
                    <p class="mb-1">
                        Surveys will be used for the purpose stated. If personally identifiable information is collected it may be
                        subject to
                        public inspection and legal disclosure and may be saved for a period of time before it is destroyed.
                    </p>
                </div>
            
                <div class="clearfix mb-3">
                    <h2> West Virginia Interactive Subscribers </h2>
            
                    <p>
                        The Information Resource of West Virginia collects, retains and utilizes personal information about its
                        customers only
                        when they volunteer to subscribe to West Virginia Interactive. The information is used to administer
                        subscriber accounts
                        and to provide products, services and other opportunities requested by West Virginia Interactive
                        subscribers. Records
                        containing personal information about West Virginia Interactive subscribers are confidential and may only be
                        released
                        with the express written permission of the subscriber pursuant to the provisions of <a
                            href="https://code.wvlegislature.gov/29B/" target="_blank" rel="noopener">West Virginia Code Chapter 29B</a>.
                    </p>
                </div>
            
                <div class="clearfix mb-3">
                    <h2> Cookies </h2>
            
                    <p>
                        In order to better serve you, the user, we use cookies for certain types of online transactions. Cookies are
                        small text
                        files that a web server may ask your web browser to store, and to send back to the web server when needed.
                        Cookies may
                        be used to store a transaction identifier or other information a user may provide. We use cookies in the
                        following ways:
                    </p>
            
                    <ul class="clearfix">
                        <li>
                            <span class="font-weight-bold">Complex Transactions:</span> Cookies are used to store and retrieve
                            unique transaction identifiers or
                            other server-generated or user-provided information in complex, multi-page web applications. This allows
                            us to
                            distinguish between different users, and to use information provided at one stage of an application at a
                            later time (for
                            instance, items placed in a 'shopping cart' might need to be displayed on a later 'check-out' screen).
                            When we use
                            cookies in this way, the cookie is stored on your web browser only temporarily; the cookie is destroyed
                            at the end of
                            the transaction or at the end of the browser session.
                        </li>
            
                        <li>
                            <span class="font-weight-bold">Customized Services:</span> Cookies may also be used to automatically
                            identify a particular user to the system, in
                            order to provide a customized service, such as a personalized web page. In this case, a cookie
                            containing a unique user
                            identifier will be permanently stored on your web browser. We do not store sensitive information in such
                            cookies; only a
                            unique user identifier or generic preference values are stored. Personal information you give us for
                            processing a
                            transaction or using one of our personalization features, may be stored on our secure web server.
                        </li>
                    </ul>
            
                    <p>
                        We do not use cookies in order to track your visit to our website. The "help" portion of the toolbar on most
                        browsers
                        will tell you how to prevent your browser from accepting new cookies or how to disable cookies altogether.
                        However,
                        cookies allow you to take full advantage of many of West Virginia's eGovernment services, and we recommend
                        that you set
                        your web browser to accept cookies.
                    </p>
            
                    <p>
                        If you have further questions about cookies, the Computer Incident Advisory Capacity unit that monitors
                        computer
                        problems for the U.S. Department of Energy issued a study on March 12, 1998 of the risks of cookies to
                        users, titled
                        Information Bulletin I-034: Internet Cookies. You can refuse the cookies or delete the cookie file from your
                        computer by
                        using any of the widely available methods.
                    </p>
                </div>
            
                <div class="clearfix mb-3">
                    <h2> Children's Online Privacy Protection Act </h2>
            
                    <p>
                        Children under the age of 13 are not eligible to use services that require submission of personal
                        information and should
                        not submit any personal information to us. This includes submitting personal information to the website as
                        part of a
                        user profile or personalization profile. If you are a child under the age of 13, you can use these services
                        only if used
                        together with your parents or guardians. Seek guidance from your parents or guardians if you are under the
                        age of 13.
                    </p>
            
                    <p>
                        If we decide to begin collecting personal information from children under the age of 13, we will notify
                        parents that it
                        is being requested, disclose the reasons for collecting it, and disclose our intended use of it. We will
                        seek verifiable
                        parental consent before collecting any personally identifiable information. If we do collect such
                        information, parents
                        may request information on the type of data being collected, view their child's information, and, if they
                        choose,
                        prohibit us from making further use of their child's information. We will not provide personal information
                        about
                        children to third parties.
                    </p>
                </div>
            
                <div class="clearfix">
                    <h2> Contact Information </h2>
            
                    <p class="mb-3">
                        To offer comments or ask questions about West Virginia privacy policies please contact:
                    </p>
            
                    <address>
                    <p class="no-mar"> 1124 Smith Street, Suite 4700 </p>
                    <p class="no-mar"> Charleston, WV 25301 </p>
                    <p class="no-mar"> (304) 766-2646 </p>
                    <p class="no-mar"> <a href="https://wv.accessgov.com/privacy/Forms/Page/privacy-office-contact/contact-privacy" target="_blank" rel="noopener"> Email Us </a> </p>
                </address>
                </div>
            </div>
        </div>
    </div>
</div>